import axios from "axios";
import { config } from "../config";

export const APiUrl = `${config.urlPlatform}/${config.urlPlatformWP}/index.php?graphql`
console.log("APiUrl", APiUrl);

export const handleGraphQLError = (error) => {
    if (axios.isAxiosError && axios.isAxiosError(error)) {
        if (
            error.response &&
            error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0
        ) {
            return error.response.data.errors[0].message;
        }
        return error.message;
    } else if (error instanceof Error) {
        return error.message;
    }
    return 'Unknown error occurred';
}

export function htmlToRichTextJson(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const body = doc.body;
  
    function parseNode(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent || '';
        if (!text.trim()) return null;
  
        return {
          data: {},
          marks: [],
          value: text,
          nodeType: 'text',
        };
      }
  
      if (node.nodeType === Node.ELEMENT_NODE) {
        const tag = node.tagName.toLowerCase();
  
        // Process children first
        let children = Array.from(node.childNodes)
          .map(parseNode)
          .filter(Boolean)
          .flat();
  
        // Inline formatting
        if (['strong', 'b'].includes(tag)) {
          children.forEach((child) => {
            if (child.nodeType === 'text') {
              child.marks.push({ type: 'bold' });
            }
          });
          return children;
        }
  
        if (['em', 'i'].includes(tag)) {
          children.forEach((child) => {
            if (child.nodeType === 'text') {
              child.marks.push({ type: 'italic' });
            }
          });
          return children;
        }
  
        // Block elements => create paragraphs
        if (['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(tag)) {
          return {
            data: {},
            content: children,
            nodeType: 'paragraph',
          };
        }
  
        // Ignore spans/wrappers that don't affect meaning
        return children;
      }
  
      return null;
    }
  
    let content = [];
  
    Array.from(body.childNodes).forEach((node) => {
      const parsed = parseNode(node);
      if (Array.isArray(parsed)) {
        content.push(...parsed);
      } else if (parsed) {
        content.push(parsed);
      }
    });
  
    return {
      data: {},
      content,
      nodeType: 'document',
    };
  }
  
